import { mdiBookMultiple } from '@lumapps/lumx/icons';

export const WIDGET_DIRECTORY_ENTRIES_TYPE = 'directory-entry';
export const WIDGET_DIRECTORY_ENTRIES_ICON = mdiBookMultiple;
export const WIDGET_DIRECTORY_ENTRIES_EDITION_SCOPE = 'widget-directory-entries-edition';
